import BaseService from '@/api/services/BaseService';

const API_RESOURCE = 'sms/user';

export default class UserService extends BaseService {
  static getUser() {
    const URI = `${API_RESOURCE}/${this.encodedUserId}`;
    const config = { headers: { 'include-children': true } };
    return this.getRequest(URI, config);
  }
}
